import { getData } from 'country-list'

import { OFAC_LIST } from 'shared/constants/countries'

const countries = getData()

export const isosToCountries = (isos = []) => countries.filter(country => isos.includes(country.code))

export const ofacFilteredCountries = countries.filter(country => !OFAC_LIST.includes(country.code))
